import { useGrowthBook } from '@growthbook/growthbook-react';

import { GB_FEATURES } from 'dpl/shared/constants/gb_features';

/**
 * exp_stories_label (CORE-6059): A/B test swapping "review(s)" for
 * "story/stories" on breeder profile and puppy page surfaces. Copy only —
 * routes, analytics props and layout are identical in both arms.
 *
 * Takes the number of stories the surface is labelling so the flag is only
 * evaluated (and the buyer only logged as exposed) when there is a label to
 * see; a breeder with zero stories renders nothing in either arm.
 */
export default function useStoriesLabel(storiesCount: number) {
  const growthbook = useGrowthBook();
  const isStoriesLabel =
    storiesCount > 0 &&
    growthbook?.getFeatureValue(GB_FEATURES.EXP_STORIES_LABEL, 'control') ===
      'variant';

  const isSingular = storiesCount === 1;
  const review = isSingular ? 'review' : 'reviews';
  const story = isSingular ? 'story' : 'stories';

  return {
    isStoriesLabel,
    // Compact metadata rows: "12 reviews" → "12 stories"
    shortNoun: isStoriesLabel ? story : review,
    // Standalone count links: "12 reviews" → "12 owner stories"
    fullNoun: isStoriesLabel ? `owner ${story}` : review
  };
}
